import React from 'react';
import ReactDOM from 'react-dom/client';
import "./index.css";
import { Provider } from "react-redux";
import store from "./Redux/index";
import App from './App';
import axios from "axios";

axios.defaults.baseURL="https://cpj-production.up.railway.app"

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
  <React.StrictMode>
    <App />
  </React.StrictMode>
  </Provider>
);
